import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from "../../environments/environment";
import { ProvisionItem } from "../../models/provisionitem";
import { BaseAPIService } from "../baseapi/baseapiservice";
import { ProvisionService } from "../provision/provision.service";
import { GetFPCExecutionsRequest } from "../../models/requests/getfpcexecutionsrequest";
import { ProposerExecution } from "../../models/proposerexecution";
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ExecutionService extends BaseAPIService{

    constructor(private http: HttpClient, private provisionService: ProvisionService)
    {
        // call the BaseAPIService constructor
        super();
    }

    getExecutions(family: string, proposerexecutions: Array<ProposerExecution> = new Array<ProposerExecution>(), showonlyrecommended: boolean = false): Observable<Array<ProvisionItem>> {
            let request = new GetFPCExecutionsRequest();
            request.FPCFamily = family;
            request.PDVersion =  this.provisionService.getProvision().PDVersion;
            request.CSpec = this.provisionService.getProvision().Provision;
            request.VSpec = this.provisionService.getProvision().Provision;
            request.ProposerExecutions = proposerexecutions;
            request.ShowOnlyRecommended = showonlyrecommended;
            request.Wso2 = true;
            request.TimeValidity = this.provisionService.getValidityFlag(); // Sending false as default (time validity flag)

            // TODO: make it a get?
            return this.http.post<Array<ProvisionItem>>(environment.baseurl + 'Structure/FPCExecutions', request).pipe(
                catchError(this.handleError)
            );
    }
}
